import { render, staticRenderFns } from "./RetailerShortageItemsFilter.vue?vue&type=template&id=8698aec4&scoped=true&"
import script from "./RetailerShortageItemsFilter.vue?vue&type=script&lang=js&"
export * from "./RetailerShortageItemsFilter.vue?vue&type=script&lang=js&"
import style0 from "./RetailerShortageItemsFilter.vue?vue&type=style&index=0&id=8698aec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8698aec4",
  null
  
)

export default component.exports